<template>
  <div class="app">
    <AppHeader ref="header" v-on:Settings="onSettings" />
    <div class="app-body">
      <AppSidebar ref="AppSidebar"/>
      <main class="main">
        <breadcrumb :list="list"/>
        <div class="container-fluid">
          <router-view></router-view>
        </div>
      </main>
      <AppAside/>
    </div>
    <AppFooter/>
  </div>
</template>

<script>
import AppHeader from '@/containers/layout/Header'
import AppSidebar from '@/containers/layout/Sidebar'
import AppAside from '@/containers/layout/Aside'
import AppFooter from '@/containers/layout/Footer'
import Breadcrumb from '@/containers/layout/Breadcrumb'
import handoffGuard from '@/mixins/handoffGuard'
// import PermissionMixin from '@/store/module/permission/mixin'
// import { actionTypes as PermissionActions } from '@/store/module/permission/actions'

export default {
  name: 'full',
  mixins: [handoffGuard],
  components: {
    AppHeader,
    AppSidebar,
    AppAside,
    AppFooter,
    Breadcrumb
  },
  computed: {
    name () {
      return this.$route.name
    },
    list () {
      return this.$route.path.split('/')
    }
  },
  methods: {
    onSettings () {
      this.$refs.AppSidebar.showMenuSettings()
    }
  }
}
</script>

<style scoped>
.container-fluid {
  height: 100%;
}
.main {
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/containers/PrivateBaseLayout.vue